import {Stack, Typography} from '@mui/material';
import {StyledCard, StyledGrid} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import React, {PropsWithChildren} from 'react';
import {CardEmptyProps} from './types';

const {titleEmpty} = translations['pt-br'].commons;

const CardEmpty = ({children, title, illustration}: PropsWithChildren<CardEmptyProps>) => (
	<StyledCard.Container sx={{height: '100%', p: '24px'}}>
		<StyledGrid.Root>
			<StyledGrid.Item lg={6}>
				<Stack sx={{justifyContent: 'center', height: '100%', gap: '16px'}}>
					<Typography fontSize={'1.25rem'} fontWeight={600}>
						{title || titleEmpty}
					</Typography>
					{children ? <Stack sx={{fontSize: '1rem'}}>{children}</Stack> : null}
				</Stack>
			</StyledGrid.Item>
			{illustration ? (
				<StyledGrid.Item lg={6}>
					<Stack sx={{justifyContent: 'center', alignItems: 'center'}}>
						{illustration}
					</Stack>
				</StyledGrid.Item>
			) : null}
		</StyledGrid.Root>
	</StyledCard.Container>
);

export {CardEmpty};
